import { Link } from "react-router-dom";

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[620px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20abstract%20illustration%20of%20Korean%20webtoon%20panels%20floating%20in%20a%20dreamy%20space%20with%20soft%20pastel%20gradient%20background%2C%20comic%20speech%20bubbles%2C%20delicate%20line%20art%20style%2C%20warm%20coral%20and%20cream%20color%20palette%2C%20ethereal%20atmosphere%2C%20clean%20minimalist%20artistic%20composition%20with%20gentle%20texture&width=1600&height=900&seq=hero-bg-manhwa&orientation=landscape"
          alt="韩漫漫画网 - 免费韩漫在线阅读平台"
          className="w-full h-full object-cover"
          title="韩漫漫画网 - 免费韩漫在线阅读"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/45"></div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-3xl mx-auto">
          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-4 leading-tight">
            发现你的下一部
            <span className="text-accent-300">挚爱韩漫</span>
          </h1>
          <p className="text-base md:text-lg text-white/80 mb-8 max-w-xl mx-auto leading-relaxed">
            韩漫漫画网汇聚免费韩漫、海量漫画大全、优质在线漫画及精选韩国漫画，致力于提供专业的阅读服务。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/category/romance"
              className="bg-primary-500 text-white text-sm md:text-base font-medium px-8 py-3.5 rounded-md hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              立即探索
            </Link>
            <Link
              to="/about"
              className="text-white/90 text-sm md:text-base font-medium px-8 py-3.5 rounded-md border border-white/30 hover:bg-white/10 transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              了解更多
            </Link>
          </div>
          <div className="mt-10 flex items-center justify-center gap-8">
            <div className="text-center">
              <p className="text-2xl md:text-3xl font-bold text-white">500+</p>
              <p className="text-xs md:text-sm text-white/60">精选韩漫</p>
            </div>
            <div className="w-px h-10 bg-white/20"></div>
            <div className="text-center">
              <p className="text-2xl md:text-3xl font-bold text-white">50万+</p>
              <p className="text-xs md:text-sm text-white/60">活跃读者</p>
            </div>
            <div className="w-px h-10 bg-white/20"></div>
            <div className="text-center">
              <p className="text-2xl md:text-3xl font-bold text-white">100%</p>
              <p className="text-xs md:text-sm text-white/60">免费阅读</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}